export const checkHasOwnerRole = (roles: string[]) => {
	return roles.some((role) =>
		['AccountOwner', 'SecondaryOwner'].includes(role),
	);
};

export default checkHasOwnerRole;
